const signalRClientEventName = {
  PUBLIC_PENDING_TRAY_UPDATE_NOTIFICATION:
    'publicPendingTrayUpdateNotification',
};

export default signalRClientEventName;
